document.addEventListener('DOMContentLoaded', function() {
  // Find all collapsible content areas
  const contentAreas = document.querySelectorAll(
    '.accordion__content, .collapsible-content, .collapsible-row__content, [class*="collapsible"] .rte, [class*="accordion"] .rte, .collapsible-content__inner'
  );

  contentAreas.forEach(function(content) {
    // Get the text content
    let html = content.innerHTML;
    let text = content.textContent || content.innerText;
    
    // Check if content has "Label: Value" pattern (at least 2 lines with colons)
    let lines = text.split('\n').filter(line => line.trim() !== '');
    let colonLines = lines.filter(line => line.includes(':'));
    
    // Only convert if most lines have the Label: Value format
    if (colonLines.length >= 2 && colonLines.length >= lines.length * 0.5) {
      let tableHTML = '<table class="auto-table">';
      
      lines.forEach(function(line) {
        let trimmedLine = line.trim();
        if (trimmedLine !== '' && trimmedLine.includes(':')) {
          // Split only on first colon to preserve colons in values (like time, URLs)
          let colonIndex = trimmedLine.indexOf(':');
          let label = trimmedLine.substring(0, colonIndex).trim();
          let value = trimmedLine.substring(colonIndex + 1).trim();
          
          if (label !== '' && value !== '') {
            tableHTML += '<tr>';
            tableHTML += '<td>' + label + '</td>';
            tableHTML += '<td>' + value + '</td>';
            tableHTML += '</tr>';
          }
        }
      });
      
      tableHTML += '</table>';
      content.innerHTML = tableHTML;
    }
  });
});